import {NgModule, ModuleWithProviders} from '@angular/core';
import {WindowRef, BrowserWindowRef} from './window-reference.service';

@NgModule({})
export class WindowReferenceModule {
  static forBrowser(): ModuleWithProviders<WindowReferenceModule> {
    return {
      ngModule: WindowReferenceModule,
      providers: [{provide: WindowRef, useClass: BrowserWindowRef}]
    };
  }
}
